import toast, { Toaster } from "react-hot-toast";
import { IoIosClose } from "react-icons/io";
import { MdCheckCircle, MdErrorOutline, MdInfoOutline, MdStar } from "react-icons/md";

const toastBaseClasses = "flex items-center justify-between p-3 rounded-xl shadow-md  break-words transform transition-all duration-300";

export const showToast = {
  success: (message) =>
    toast.custom((t) => (
      <div
        className={`${toastBaseClasses} bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 border-l-4 border-green-500 ${t.visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
      >
        <div className="flex items-center gap-2">
          <MdCheckCircle className="w-6 h-6" />
          <span>{message}</span>
        </div>
        <button
          className="ml-2 p-1 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 flex items-center justify-center"
          onClick={() => toast.dismiss(t.id)}
        >
          <IoIosClose className="w-4 h-4" />
        </button>
      </div>
    ), { duration: 4000 }),

  error: (message) =>
    toast.custom((t) => (
      <div
        className={`${toastBaseClasses} bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 border-l-4 border-red-500 ${t.visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
      >
        <div className="flex items-center gap-2">
          <MdErrorOutline className="w-6 h-6" />
          <span>{message}</span>
        </div>
        <button
          className="ml-2 p-1 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 flex items-center justify-center"
          onClick={() => toast.dismiss(t.id)}
        >
          <IoIosClose className="w-4 h-4" />
        </button>
      </div>
    ), { duration: 4000 }),

  info: (message) =>
    toast.custom((t) => (
      <div
        className={`${toastBaseClasses} bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 border-l-4 border-blue-500 ${t.visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
      >
        <div className="flex items-center gap-2">
          <MdInfoOutline className="w-6 h-6" />
          <span>{message}</span>
        </div>
        <button
          className="ml-2 p-1 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 flex items-center justify-center"
          onClick={() => toast.dismiss(t.id)}
        >
          <IoIosClose className="w-4 h-4" />
        </button>
      </div>
    ), { duration: 4000 }),

  custom: (message) =>
    toast.custom((t) => (
      <div
        className={`${toastBaseClasses} bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 border-l-4 border-indigo-500 ${t.visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
      >
        <div className="flex items-center gap-2">
          <MdStar className="w-6 h-6" />
          <span>{message} <b>bold</b></span>
        </div>
        <button
          className="ml-2 p-1 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 flex items-center justify-center"
          onClick={() => toast.dismiss(t.id)}
        >
          <IoIosClose className="w-4 h-4" />
        </button>
      </div>
    ), { duration: 4000 }),
};

export const ToastContainer = () => <Toaster position="top-right" />;
